import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import uuid from 'uuid/v4';
import { VisuallyHidden } from '@react-aria/visually-hidden';
import ProductAttrCell from './ProductAttrCell';


const ProductComparisonRows = function ProductComparisonRowsComponent({
  rows,
  isExpanded,
}) {
  return (
    rows.map((row, rowIndex) => {
      if (row.isCustom && !isExpanded) {
        return null;
      }

      const rowClassNames = classNames(
        'product-table__row',
        `product-table__row--${row.key}`,
      );

      return (
        <tr key={row.key} className={rowClassNames} aria-rowindex={rowIndex + 1}>
          {row.displayRowHeaderLabel ?
            (
              <th className="product-table__table-cell product-table__table-heading">
                {row.rowHeaderLabel}
              </th>
            ) :
            (
              <th className="product-table__table-cell product-table__table-heading">
                <VisuallyHidden>
                  {row.rowHeaderLabel}
                </VisuallyHidden>
              </th>
            )
          }
          {row.rowCells.map((cell) => {
            const cellClassNames = classNames(
              'product-table__table-cell',
              {
                'product-table__table-cell--features': row.rowHeaderLabel === 'Features',
              },
            );

            return (
              <td key={uuid()} className={cellClassNames}>
                <ProductAttrCell attrKey={row.key} productAttr={cell} />
              </td>
            );
          })}
        </tr>
      );
    })
  );
};

ProductComparisonRows.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isExpanded: PropTypes.bool.isRequired,
};

export default ProductComparisonRows;
